<template>
  <div>
    <div>
      <v-carousel height="100wh" show-arrows-on-hover :hide-delimiters="hideDelimiters" :cycle="cycle">
        <v-carousel-item>
          <v-img
            :src="$vuetify.breakpoint.mdAndUp ? `${publicPathImg}imagenes/home-hor.jpg` : `${publicPathImg}imagenes/home-ver.jpg`"
            height="100vh"
            class="align-center"
            gradient="to top right, rgba(0,0,0,.10), rgba(0,0,0,.10)"
          >
            <h1
              class="white--text text-center font-weight-bold text-uppercase"
              :class="[$vuetify.breakpoint.xl ? 'display-4' : $vuetify.breakpoint.mdAndUp ? 'display-2' :  'display-1']"
            >Bienvenido al {{city_options.name}}</h1>
          </v-img>
        </v-carousel-item>              
        <v-carousel-item v-for="item in sliders" v-bind:key="item.id">
          <v-img
            :src="renderImage(item.image)"
            v-if="$vuetify.breakpoint.mdAndUp"
            height="100vh"
            class="align-center"
            gradient="to top right, rgba(0,0,0,.10), rgba(0,0,0,.10)"
          >
          </v-img>
          <v-img
            :src="renderImage(item.movil_image)"
            v-else
            height="100vh"
            class="align-center"
            gradient="to top right, rgba(0,0,0,.10), rgba(0,0,0,.10)"
          >
          </v-img>
        </v-carousel-item>    
      </v-carousel> 
    </div>
    <Estatus :iconos="dataPrincipal.iconos"/>
    <div v-if="dataPrincipal.description != null">
      <v-row
        class="justify-center align-center"
        :class="[$vuetify.breakpoint.mdAndUp ? 'px-12' : 'mx-0 px-5']"
      >
        <v-col
          cols="12"
          class="py-12"
        >
          <div v-html="dataPrincipal.description.content" class="contentEditor"></div>
          <div class="d-flex justify-center align-center pt-6">
            <router-link
              class="v-btn v-btn--depressed v-btn--flat v-btn--outlined v-btn--rounded theme--light v-size--large"
              :to="link_information"
            >Solicita informes</router-link>
          </div>          
        </v-col>
      </v-row>
    </div> 
    <div class="py-12 primary" style="overflow: overlay;">
      <v-row :class="[$vuetify.breakpoint.mdAndUp ? '' : 'mx-0 px-2']">
        <v-col
          cols="12"
          sm="12"
          md="6"
          lg="5"
          xl="4"
          offset-lg="1"
          offset-xl="2"
          class="d-flex justify-center align-center"
        >
          <v-img
            :src="`${publicPathImg}imagenes/mapa.png`"
            :max-width="$vuetify.breakpoint.xl ? '25vw' : ''"
          ></v-img>
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="5" xl="4" class="px-5 align-center d-flex">
          <div class="text-center">
            <h1
              class="font-weight-bold text-uppercase pb-5 text-center white--text"
            >12 colegios, en 20 años</h1>
            <h3 align="justify" class="font-weight-regular white--text">
              Colegio Vizcaya, contribuye al desarrollo de
              las regiones donde se establecen sus diferentes planteles, fomentando
              la educación y cultura en sus diversas expresiones, formando
              profesionales competitivos, exitosos y leales, comprometidos con
              la excelencia, como manifestación de superación personal.
            </h3>
            <v-btn
              outlined
              light
              rounded
              class="white--text mt-5 mx-3"
              @click="dialogVideo = !dialogVideo"
            >
              Ver vídeo
              <v-icon right>mdi-play-circle</v-icon>
            </v-btn>
          </div>
          <br />
          <!--<v-btn outlined light rounded href="/sistema">Conoce más nuestro sistema educativo</v-btn>-->
        </v-col>
      </v-row>
    </div>
    <v-dialog
      :max-width="$vuetify.breakpoint.mdAndUp ? '50vw' : '100vw'"
      tile
      v-model="dialogVideo"
    >
      <div style="text-align: right">
        <v-btn text dark icon @click="dialogVideo = !dialogVideo">
          <i class="mdi mdi-close"></i>
        </v-btn>
      </div>

      <v-card>
        <iframe
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
          src="https://www.youtube.com/embed/bTLBeoBjc40"
          style="height: 50vh;"
          frameborder="0"
          width="100%"
        ></iframe>
      </v-card>
    </v-dialog>
    <LeftImage
      :textArray="textArray"
      :hasTitle="true"
      title="NUESTRO OBJETIVO PRIMORDIAL"
      titleClass="mb-5"
      image="/imagenes/objetivo.jpg"
      colClass="py-12"
    />
    <div class="uva" v-if="dataPrincipal.banner != null">
      <v-layout
        column
        align-center
        justify-center
        fill-height
        class="white--text"
        style="position: relative; height: 80vh;"
      >
        <div
          v-bind:style="{ backgroundImage: 'url('+renderImage(dataPrincipal.banner.image)+')' }"
          style="background-size: cover;height: 100%;width: 100%;position: absolute;background-position: center;z-index: 1;'"
        ></div>
        <div
          style="position: absolute;    z-index: 2;    height: 100%;    width: 100%; background-color: rgba(0,0,0,0.3);"
        ></div>
        <h1
          class="white--text text-uppercase font-weight-bold mb-5 text-center"
          style="z-index: 3;"
          :class="[
            $vuetify.breakpoint.mdAndUp
              ? 'display-1 '
              : 'display-1 text-center',
          ]"
        >
          {{dataPrincipal.banner.title}}
        </h1>

        <div
          class="justify-center align-center d-flex"
          :class="[$vuetify.breakpoint.mdAndUp ? 'flex-row' : 'flex-column']"
          style="z-index: 3;"
        >
          <router-link style="text-decoration:none" :to="{ name: 'informate' }">
            <v-btn
              class="mt-5 mx-3 text-uppercase"
              dark
              outlined
              rounded
              color="white"
              x-large
              >{{dataPrincipal.banner.subtitle}}</v-btn
            >
          </router-link>
        </div>
      </v-layout>
    </div>
    <ColorBanner
      :title="title"
      :description="description"
      bgcolor="pattern-secondary"
      titleClass="mb-5"
    />
    <v-row class="mx-0" align="center" justify="center" style="background-color:#8e0d2c">
      <v-col cols="10" sm="10" md="12" lg="6">
        <h1
          :class="$vuetify.breakpoint.mdAndUp ? 'display-2' : ''"
          class="white--text text-center text-uppercase my-12 font-weight-regular"
        >Conoce nuestras instalaciones</h1>
      </v-col>
    </v-row>
    <v-row v-for="the_row in instalaciones" :key="the_row.id" class="justify-center align-center px-12" :class="[$vuetify.breakpoint.mdAndUp ? '' : 'mx-0 px-5']">
      <v-col cols="12" :sm="the_row.length == 3 ? 4 : (the_row.length == 2 ? 6 : 12)" v-for="the_row_son in the_row" :key="the_row_son.id">
        <v-img @click.stop="dialog = true,picture = the_row_son.picture" :src="renderImage(the_row_son.picture)" aspect-ratio="1.7"></v-img>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" max-width="600">
      <v-img :src="renderImage(picture)">
        <template v-slot:placeholder>
          <v-row class="fill-height ma-0" align="center" justify="center">
            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
          </v-row>
        </template>
      </v-img>
    </v-dialog>
  </div>
</template>
<style lang="scss" scoped>
.pt-header {
  padding-top: 120px;
}
.container {
  padding-left: 20%;
  padding-right: 20%;
}
ul {
  list-style: none;
}
.the-background {
  background-color: #681342;
}
</style>
<script>
import { mapState } from "vuex";
import axios from "axios";
import lodash from "lodash";
import Estatus from "../components/Estatus.vue";
import LeftImage from "../components/LeftImage.vue";
import ColorBanner from "../components/ColorBanner.vue";
export default {
  components: {
    Estatus,
    LeftImage,
    ColorBanner
  },
  mounted() {
    this.sendInfoData();
    var self = this
    axios({
      method: "post",
      data: {from: "Colegio"},
      url: "https://adminuva.tidingo.com/api/data-principal",
      config: {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json"
        },withCredentials: true, credentials: "same-origin"
      }
    }).then(function(response) {
      self.dataPrincipal = response.data
    }).catch(function(error) {});    
  },
  data: () => ({
    dataPrincipal:{
      alianzas:[],
      iconos:[],
      banner:null,
      description:null,
    },    
    cycle: true,
    hideDelimiters: true,
    arrows: true,
    dialog: false,
    picture: null,
    publicPathImg: process.env.BASE_URL,
    dialogVideo: false,
    publicPath: "https://adminuva.tidingo.com/",
    instalaciones: [],
    valores: [
      "Lealtad",
      "Disciplina",
      "Espíritu de Servicio",
      "Respeto",
      "Responsabilidad",
      "Honestidad"
    ],
    textArray: [
      {
        text:
          "Promover en nuestros alumnos el desarrollo integral, en todos sus potenciales tanto humano, físico, psíquico, emocional, afectivo y social, fomentando que su aprendizaje parta de los conocimientos que ya poseen y tengan un valor para ellos."
      },
      {
        text:
          "Propiciar la capacidad de interactuar respetuosa y afectuosamente, cooperando con los otros, haciendo de los educandos, seres observadores, críticos, reflexivos y humanamente formados."
      }
    ],
    title: "Conócenos",
    description:
      "Nuestro objetivo es la formación integral de la persona, en un ambiente de confianza, intercambio personal y colaboración. Dentro del cual cada una se sienta reconocida, valorada, aceptada y estimulada para conquistar su propio desarrollo y adquirir un compromiso de respuesta."
  }),
  watch: {
    city_options() {
      this.sendInfoData();
    }
  },
  methods: {
    onScroll(e) {
      this.offsetTop = window.scrollY;
    },
    sendInfoData() {
      var self = this;
      var url =
        "https://adminuva.tidingo.com/api/installation-list-by-campus?webpage=Colegio&campus=";
      var cselected = self.city_options.name;
      axios({
        method: "get",
        url: url + cselected,
        config: {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json"
          },
          withCredentials: true,
          credentials: "same-origin"
        }
      })
        .then(function(response) {
          var val = response.data.data;
          if ( (val.length % 3) == 0 ){
            var general = _.chunk(val, 3);
            var total = [];
            for (var i = 0; i < general.length; i++) {
              var rand = Math.floor(Math.random() * 2);
              rand = rand + 1;
              switch(rand) {
                case 1:
                  var the_result =  _.chunk(general[i], 2);
                  for (var da = 0; da < the_result.length; da++) {
                    total.push(the_result[da]);
                  }
                  break;
                case 2:
                  total.push(general[i]);
                  break;
              }            
            }
            self.instalaciones =  total;
          }else{
            self.instalaciones =  _.chunk(val, 3);
          }
        })
        .catch(function(error) {
        });
    },
    renderImage(image){
      if(image!=null){
        if(image.indexOf("https")<0){
          return "https://adminuva.tidingo.com/"+image;
        }else{
          return image;
        }
      }else{
        return "";
      }
    }
  },
  computed: {
    ...mapState({
      sliders: state => state.cities.sliders,
      campus: state => state.cities.campus,
      city_options: state => state.cities.city_options,
      city_selected: state => state.cities.city_selected,
      cities: state => state.cities.cities,
      cities2: state => state.cities.cities2,
      referenceStore: state => state.cities.referenceStore,
      link_information: state => state.cities.link_information
    })
  }
};
</script>
